// Cap-table repository — PSD §3.5, P1.16. Persistence layer.

import type { CapTable } from '@backsolve/shared-types';
import { getDB } from './db';

export async function saveCapTable(cap: CapTable): Promise<void> {
  const db = await getDB();
  await db.put('capTableSnapshots', cap);
}

export async function loadCapTable(id: string): Promise<CapTable | undefined> {
  const db = await getDB();
  return db.get('capTableSnapshots', id);
}

export async function listCapTablesByEntity(entityName: string): Promise<CapTable[]> {
  const db = await getDB();
  const all = (await db.getAll('capTableSnapshots')) as CapTable[];
  return all
    .filter((c) => c.entityName === entityName)
    .sort((a, b) => b.version - a.version);
}
